// extracted by mini-css-extract-plugin
export default {"AuthSearch":"AuthSearch_AuthSearch__JXqSG"};